/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_Delete_ConfirmInputs */

const vi_product_classification_delete_confirm = /** @type {(inputs: Product_Classification_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa phân loại này?`)
};

/**

* @param {Product_Classification_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_delete_confirm = /** @type {((inputs?: Product_Classification_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_delete_confirm(inputs)
});